import React from 'react';
import { motion } from 'framer-motion';
import { FileText, BookOpen, Gavel, Target, CheckSquare, Zap, Bot } from 'lucide-react';
export const Included = () => {
  const items = [{
    icon: <FileText className="w-8 h-8 text-gold-500" data-id="element-152" />,
    title: 'Modelos profesionales.',
    desc: 'Demandas, contratos, escritos, recursos, cautelares, intimaciones y documentos listos para adaptar.'
  }, {
    icon: <Bot className="w-8 h-8 text-gold-500" data-id="element-153" />,
    title: 'IA Jurídica Aplicada.',
    desc: 'Prompts, automatizaciones y sistemas para utilizar inteligencia artificial en el ejercicio profesional.'
  }, {
    icon: <Gavel className="w-8 h-8 text-gold-500" data-id="element-154" />,
    title: 'Jurisprudencia y estrategias.',
    desc: 'Argumentos, fallos y criterios organizados para ahorrar tiempo de investigación.'
  }, {
    icon: <Target className="w-8 h-8 text-gold-500" data-id="element-155" />,
    title: 'Marketing y captación.',
    desc: 'Herramientas para conseguir clientes, convertir consultas y hacer crecer tu estudio.'
  }, {
    icon: <CheckSquare className="w-8 h-8 text-gold-500" data-id="element-156" />,
    title: 'Checklists y herramientas.',
    desc: 'Procesos, controles y sistemas que reducen errores y mejoran resultados.'
  }, {
    icon: <Zap className="w-8 h-8 text-gold-500" data-id="element-157" />,
    title: 'Acceso inmediato.',
    desc: 'Recibís todo el material apenas se acredita el pago.'
  }];
  return <section className="py-20 bg-legal-900" data-id="element-158">
      <div className="container mx-auto px-4" data-id="element-159">
        <div className="text-center mb-16" data-id="element-160">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-161">
            Todo en un solo lugar.
          </h2>
          <p className="text-slate-400 text-lg" data-id="element-162">
            Las herramientas esenciales para tu práctica profesional.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-163">
          {items.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-legal-800 border border-legal-700 p-8 rounded-xl hover:border-gold-500/50 transition-colors group" data-id="element-164">
              <div className="mb-6 p-3 bg-legal-900 rounded-lg inline-block group-hover:scale-110 transition-transform" data-id="element-165">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-166">
                {item.title}
              </h3>
              <p className="text-slate-400 leading-relaxed" data-id="element-167">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};